export default defineNuxtPlugin(async (nuxtApp) => {
  try {
    const { userAgent } = useDevice()
    const supportedBrowsers = useRuntimeConfig().public.confGlobal.supportedBrowsers
  
    /**
    * Browser Detect
    */
    const browserVersion = (function () {
      const ua = userAgent
      let tem
      let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || []

      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || []
        return 'IE ' + (tem[1] || '')
      }

      if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
        if (tem != null) {
          return tem.slice(1).join(' ').replace('OPR', 'Opera')
        }
      }

      M = [M[1], M[2]]
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1])
      }

      return M
    })()

    const isSupportedBrowser = browserVersion[1] * 1 >= supportedBrowsers[browserVersion[0]]
    
    /**
    * Get IP
    */
    const { data } = useFetch('/api/ip', {
      method: 'GET',
      transform(input) {
        return {
          ...input,
          fetchedAt: new Date()
        }
      },
      getCachedData(key) {
        const data = useNuxtApp().payload.data[key] || useNuxtApp().static.data[key]
        if (!data) {
          return
        }

        const expirationDate = new Date(data.fetchedAt)
        expirationDate.setTime(expirationDate.getTime() + 10 * 1000)
        const isExpired = expirationDate.getTime() < Date.now()
        if(isExpired) {
          return
        }

        return data
      }
    })
    
    nuxtApp.provide('isSupportedBrowser', isSupportedBrowser)
    nuxtApp.provide('ip', data.value?.ip)
  } catch (err) {
    console.log(err)
  }
})